<template>
  <div class="gc-actions-menu" ref="root" @click.stop>
    <button
      type="button"
      class="gc-actions-toggle"
      :class="{ open: open }"
      :disabled="disabled"
      ref="toggle"
      @click.stop="toggle"
    >
      <span>{{ label }}</span>
      <span class="gc-actions-caret">v</span>
    </button>

    <div
      v-if="open"
      ref="panel"
      class="gc-actions-panel"
      :class="'align-' + align"
      :style="panelStyle"
      @click.capture="closeAfterSelect"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminActionMenu',
  props: {
    label: {
      type: String,
      default: 'Actions'
    },
    align: {
      type: String,
      default: 'right'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      open: false,
      panelStyle: null
    }
  },
  mounted () {
    document.addEventListener('mousedown', this.onDocumentDown)
    document.addEventListener('keydown', this.onDocumentKey)
    window.addEventListener('resize', this.close)
    window.addEventListener('scroll', this.close, true)
  },
  beforeDestroy () {
    document.removeEventListener('mousedown', this.onDocumentDown)
    document.removeEventListener('keydown', this.onDocumentKey)
    window.removeEventListener('resize', this.close)
    window.removeEventListener('scroll', this.close, true)
  },
  methods: {
    toggle () {
      if (this.disabled) return
      if (this.open) {
        this.close()
        return
      }
      this.open = true
      this.$nextTick(this.positionPanel)
    },
    close () {
      this.open = false
      this.panelStyle = null
    },
    positionPanel () {
      const toggle = this.$refs.toggle
      const panel = this.$refs.panel
      if (!toggle || !panel) return
      const rect = toggle.getBoundingClientRect()
      const width = panel.offsetWidth || 168
      const height = panel.offsetHeight || 40
      const gap = 7
      let left = this.align === 'left' ? rect.left : rect.right - width
      let top = rect.bottom + gap

      left = Math.max(8, Math.min(left, window.innerWidth - width - 8))
      if (top + height > window.innerHeight - 8) {
        top = Math.max(8, rect.top - height - gap)
      }
      this.panelStyle = {
        left: left + 'px',
        top: top + 'px'
      }
    },
    closeAfterSelect () {
      setTimeout(() => { this.open = false }, 0)
    },
    onDocumentDown (event) {
      const root = this.$refs.root
      if (!root || root.contains(event.target)) return
      this.close()
    },
    onDocumentKey (event) {
      if (event && event.key === 'Escape') this.close()
    }
  }
}
</script>

<style scoped>
.gc-actions-menu {
  position: relative;
  display: inline-flex;
  justify-content: flex-end;
  min-width: 0;
}

.gc-actions-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-width: 92px;
  height: 30px;
  padding: 0 11px;
  border: 1px solid rgba(25, 151, 198, 0.68);
  border-radius: 6px;
  background: rgba(8, 22, 31, 0.72);
  color: #1fb2e8;
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.gc-actions-toggle:hover:not(:disabled),
.gc-actions-toggle.open {
  border-color: rgba(38, 190, 239, 0.9);
  background: rgba(18, 64, 86, 0.74);
  color: #eaf7fc;
}

.gc-actions-toggle:disabled {
  cursor: default;
  opacity: 0.5;
}

.gc-actions-caret {
  font-size: 12px;
  line-height: 1;
}

.gc-actions-panel {
  position: fixed;
  z-index: 3000;
  display: grid;
  gap: 6px;
  width: 168px;
  padding: 8px;
  border: 1px solid rgba(67, 72, 87, 0.95);
  border-radius: 8px;
  background:
    radial-gradient(circle at 20% 0%, rgba(25, 151, 198, 0.12), transparent 42%),
    rgba(8, 12, 18, 0.98);
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.42);
}

::v-deep(.row-btn),
::v-deep(.btn-run),
::v-deep(a) {
  width: 100%;
  min-width: 0;
  justify-content: center;
  text-align: center;
}

::v-deep(a) {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  border-radius: 6px;
  color: #1fb2e8;
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
}

::v-deep(a:hover) {
  background: rgba(25, 151, 198, 0.1);
  color: #eaf7fc;
}
</style>
